import styled from "@emotion/styled";
import { Box, Button as MuiButton } from "@mui/material";

import { theme } from "../../mui-customs/Theme";

export const StyledContainer = styled(Box)`
  width: 100%;
  padding: 16px;
  background: ${theme.whiteBg.WBG2};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 0.7px solid ${theme.whiteBg.WBG4};
`;
